<template>
  <div>
    <DashboardHeader title="Post Read">
      <v-layout row wrap class="mt-4">
        <v-flex xs12 md5 class="mx-4">
          <VueFluxSlider :images="images"></VueFluxSlider>
        </v-flex>
        <v-flex xs12 md6>
          <v-card>
            <v-card-title v-html="post.title"></v-card-title>
            <v-card-subtitle>Author: {{post.name}} | Date: {{post.date_posted}}</v-card-subtitle>
            <v-card-text v-html="post.body"></v-card-text>
            <v-card-actions>
              <v-btn class="mx-2" @click="goBack()" large dark rounded :color="getThemeColor">Back</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </DashboardHeader>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import DashboardHeader from "@/components/DashboardHeader.vue";
import VueFluxSlider from "@/components/myLibrary/VueFluxSlider.vue";

export default {
  props: ["post"],
  components: { DashboardHeader, VueFluxSlider },
  computed: {
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getApiUrl() {
      return this.$store.getters.getApiUrl;
    },
    getUserSchool() {
      return this.$store.getters.getUserSchool;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    }
  },
  mounted() {
    this.folder =
      "posts/" + this.getUserSchool.emis + "/" + this.post.picture_folder;
    this.getImages();
  },
  data: () => ({
    folder: null,
    images: []
  }),
  methods: {
    goBack() {
      this.$router.back();
    },
    getImages() {
      this.$store.commit("setLoader", true);
      this.images = [];
      axios
        .postDataWithToken(
          "/auth/get-images-for-given-folder",
          {
            folder: this.folder
          },
          this.getAccessToken
        )
        .then(images => {
          images.forEach(image => {
            this.images.push(
              this.getApiUrl +
                "/images/" +
                this.folder +
                "/" +
                this.getUserSchool.emis +
                "/" +
                image
            );
          });

          this.$store.commit("setLoader", false);
        });
    }
  }
};
</script>

<style>
</style>